<template>
    <textarea class="form-control"
              v-bind:class="{'is-invalid' : attributeError}"
              v-bind:required="required"
              v-bind:name="name">
    </textarea>
</template>

<script>
require('summernote/dist/summernote-bs4');
require('summernote/lang/summernote-es-ES');
require('../../../plugins/summernote-list-styles/summernote-list-styles-bs4');

require('summernote/dist/summernote-bs4.css');
require('../../../plugins/summernote-list-styles/summernote-list-styles-bs4.css');

import sanitizeHtml from 'sanitize-html';

export default {
    name: "SummerTextArea",
    props: {
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        name: {
            type: String,
            required: true,
        },
        value: {
            type: String | HTMLElement,
            default: '',
        }
    },
    data() {
        return {
            attributeError: '',
            errors: window.data.errors,
        }
    },
    beforeMount() {
        this.attributeError = this.errors[this.attribute] ? this.errors[this.attribute] : [''];
    },
    mounted() {
        this.createEditor();
    },
    methods: {
        createEditor() {
            let template = this;
            $(this.$el).summernote({
                lang: 'es-ES',
                toolbar: [
                    ['style', ['style', 'hr']],
                    ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
                    ['fontname', ['fontname', 'fontsize']],
                    ['color', ['color']],
                    ['para', ['ul', 'ol', 'listStyles', 'paragraph', 'height']],
                    ['table', ['table']],
                    ['insert', ['link', 'picture', 'video']],
                    ['view', ['undo', 'redo', 'fullscreen', 'codeview']],
                ],
                callbacks: {
                    onInit: function () {
                        $(template.$el).summernote("code", template.value);
                    },
                    onChange: function () {
                        template.$emit('change', $(template.$el).summernote('code'));
                    },
                    onBlur: function () {
                        template.$emit('change', $(template.$el).summernote('code'));
                    },
                    onPaste: function (e) {
                        e.preventDefault();
                        const bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                        const parser = new DOMParser();
                        let htmlText = parser.parseFromString(bufferText, 'text/html');

                        // Delete all styles & sanitize
                        const sanitized = sanitizeHtml(htmlText.documentElement.innerHTML);

                        setTimeout(function () {
                            document.execCommand('insertText', false, sanitized);
                        }, 10);
                    }
                },
            });
        },
    }
}
</script>

<style>
.note-editable {
    min-height: 5rem;
    background-color: white;
    color: black;
}

@font-face {
    font-family: "summernote";
    font-style: normal;
    font-weight: 400;
    font-display: auto;
    src: url(/webfonts/summernote.eot);
    src: url(/webfonts/summernote.eot?#iefix) format("embedded-opentype"), url(/webfonts/summernote.woff2) format("woff2"), url(/webfonts/summernote.woff) format("woff"), url(/webfonts/summernote.ttf) format("truetype");
}
</style>
